import { useMemo } from 'react';
import { hydrateFields } from 'ContentComponents/components/cmv2/utils';
import { useBindingState } from 'ContentComponents/components/cmv2/hooks/useBindingState';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withBindingState(Component) {
  const Wrapper = props => {
    const {
      moduleSpec,
      module,
      isInGlobalStyles,
      isInNewEditor,
      bindings,
      onBindingsChange,
      variantFieldKeyPrefix
    } = props;
    const fields = useMemo(() => hydrateFields(props),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [moduleSpec === null || moduleSpec === void 0 ? void 0 : moduleSpec.fields]);
    const bindingState = useBindingState({
      fields,
      module,
      isInGlobalStyles,
      isInNewEditor,
      initialBindings: bindings,
      onBindingsChange,
      variantFieldKeyPrefix
    });
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      bindingState: bindingState
    }));
  };
  Wrapper.displayName = `withBindingState(${Component.displayName || Component.name || 'Component'})`;
  return Wrapper;
}